module.exports = __webpack_public_path__ + "static/img/xiandainongyezhan.93cd4185.png";